import type { Quota } from '@/contexts/quotas/Quotas.interfaces'

export const hasReachedQuota = (quota: Quota): boolean => {
  return quota.max != null && quota.current >= quota.max
}

export const hasExceededQuota = (quota: Quota): boolean => {
  return quota.max != null && quota.current > quota.max
}

export const hasUndefinedQuota = (quota: Quota): boolean => quota.max == null
